export default __webpack_public_path__ + "static/english-title-page-a376357dc058377ae377b5e3da1d303d.jpg";